import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/hr-resources")({
  component: () => <Outlet />,
});
